import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import { getFirestore, doc, runTransaction } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCQ4_TkOu4i5H1j43E4dAG7Yv_6vgZ1P68",
  authDomain: "nexrise-internal.firebaseapp.com",
  projectId: "nexrise-internal",
  storageBucket: "nexrise-internal.firebasestorage.app",
  messagingSenderId: "493135056072",
  appId: "1:493135056072:web:cc5beedcf77c2999e069fd",
  measurementId: "G-8WN38C2XM3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export { ref, uploadBytes, getDownloadURL };
export { GoogleAuthProvider, signInWithPopup, signOut };


const getFirmPrefix = (firmId) => {
  if (firmId.startsWith('nexrise')) return 'NIIPL';
  if (firmId.startsWith('jagdish')) return 'JE';
  if (firmId.startsWith('cloudnine')) return 'C9';
  return 'GEN';
};

export const getNextVoucherNumber = async (db, firmId) => {
  const firmPrefix = getFirmPrefix(firmId);
  const counterKey = `invoice_${firmPrefix.toLowerCase()}_count`;
  const sequencesRef = doc(db, "counters", "sequences");
  const yearCode = "25-26";

  try {
    const newCounter = await runTransaction(db, async (transaction) => {
      const sequenceDoc = await transaction.get(sequencesRef);
      if (!sequenceDoc.exists()) {
        throw new Error("Counter document does not exist!");
      }
      const currentCount = sequenceDoc.data()[counterKey] || 1000;
      const nextCount = currentCount + 1;
      transaction.update(sequencesRef, { [counterKey]: nextCount });
      return currentCount;
    });

    return `${firmPrefix}/${yearCode}/IN${newCounter}`;
  } catch (error) {
    console.error("Error getting next voucher number: ", error);
    return null;
  }
};